__turbopack_context__.v({
  "heading": "_9fvgSG_heading",
});
